module.exports = __webpack_public_path__ + "static/media/icon-game-setting.93d33a67.svg";